import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import logos from "../../misc/logos";

export default function PressSlider() {
  const { t } = useTranslation("heropage");

  return (
    <Box
      sx={{
        width: "100%",
        py: { xs: 8, md: 14 },
        backgroundColor: "#F6F5F3",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Section Title */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <Typography
          sx={{
            fontFamily: "'Playfair Display', serif",
            fontSize: { xs: "1.5rem", md: "2.5rem" },
            fontWeight: 700,
            color: "#111",
            mb: { xs: 4, md: 6 },
            textAlign: "center",
          }}
        >
          {t("press.title")}
        </Typography>
      </motion.div>

      {/* Logo Slider */}
      <Box sx={{ width: "100%", overflow: "hidden" }}>
        <motion.div
          style={{
            display: "flex",
            gap: "3rem",
          }}
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            repeat: Infinity,
            repeatType: "loop",
            duration: logos.length * 2.5,
            ease: "linear",
          }}
        >
          {logos.concat(logos).map((logo, index) => (
            <motion.div
              key={index}
              whileHover={{
                scale: 1.1,
                boxShadow: "0 15px 30px rgba(0,0,0,0.15)",
              }}
              transition={{ type: "spring", stiffness: 120 }}
            >
              <Box
                component="img"
                src={logo}
                alt={t("press.logoAlt", { index: index + 1 })}
                sx={{
                  height: { xs: 50, md: 80 },
                  objectFit: "contain",
                  filter: "grayscale(20%)",
                  transition: "filter 0.3s ease",
                  "&:hover": {
                    filter: "grayscale(0%)",
                  },
                }}
              />
            </motion.div>
          ))}
        </motion.div>
      </Box>
    </Box>
  );
}
